import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/home",
    alias: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
  },
  {
    path: "/service",
    name: "Service",
    component: () => import("../views/Service.vue"),
  },
  {
    path: "/service2",
    name: "Service2",
    component: () => import("../views/Service2.vue"),
  },
  {
    path: "/service3",
    name: "Service3",
    component: () => import("../views/Service3.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
});

export default router;
